import './Contact.css';
import Swal from 'sweetalert2';
import { useRef } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_eb5rfj6', 'template_bxme6yz', form.current, {
        publicKey: 'd4DFA04a-wXtMzuG_',
      })
      .then(
        () => {
          Swal.fire({
            title: "Skickats",
            text: "Meddelandet har skickats",
            icon: "Success"
        });
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };
  return (
    <div id='contact' className='contact_us'>
    <div className="contact-form">
      <div className="flow">
        <div className='flow_title'>Gör en förfrågan</div>
      </div>
      <form form ref={form} onSubmit={sendEmail}>
        <div className="form-group">
          <label for="name">Namn</label>
          <input type="text" name='name' required />
        </div>
        <div className="form-group">
          <label for="company">Email</label>
          <input type="email"  name='email' required />
        </div>
        <div className="form-group">
          <label for="email">Nummer</label>
          <input type="number" name='number' required />
        </div>
        <div className="form-group">
          <label for="phone">Tillställningens datum</label>
          <input type='date' name='date' className='calender' required />
        </div>
        <div className="form-group">
          <label for="phone">Antal gäster</label>
          <input type="number" name='guest' required />
        </div>
        <div className="form-group">
          <label for="phone">Typ av arrangemang</label>
          <input type="text" name='event' required />
        </div>
        <div className="form-group">
          <label for="phone">Beskriv era övriga önskemål</label>
          <textarea type='textarea' name='message' required />
        </div>
        <br />
        <button type='submit'>Skicka</button>
      </form>
    </div>
    </div>
  )
}

export default Contact